export const ServerDown = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "3rem" }}>
      🚨 Server is currently unavailable. Please try again later.
    </div>
  )
};
